import React, { useCallback } from 'react';

import { Typography, TableRow, TableCell } from '@occc/ui-design-system';
import { MarketingContentPreview } from '@occc-app/design-system';
import { publishedStatusBadge } from '@occc-app/lib/publicationStatusBadge';
import { getTitleByOfferType, getVoucherAward } from '@occc-app/offerHelpers/utils';
import { OfferType } from '@occc-app/offerValidationService/types';

import { CampaignComponent } from './types';
import { CampaignComponentsTableRowActionsContainer } from './CampaignComponentsTableRowActionsContainer';

type ComponentTableRowProps = {
  campaignComponent: CampaignComponent;
  onItemClick: (id: string) => void;
  isActionsColumnVisible: boolean;
};

export const ComponentTableRow = ({
  campaignComponent,
  onItemClick,
  isActionsColumnVisible,
}: ComponentTableRowProps) => {
  const {
    id,
    name,
    description,
    type,
    marketingContent,
    deleted,
    publishedStatus,
    fulfillmentCount,
    earningMechanism,
    disabled,
  } = campaignComponent;

  const handleItemClick = useCallback(() => {
    if (disabled) return;
    onItemClick(id);
  }, [disabled, id, onItemClick]);

  const voucherAward = getVoucherAward(earningMechanism);

  return (
    <TableRow onClick={handleItemClick} hover={!disabled} sx={{ opacity: disabled ? 0.5 : 1 }}>
      <TableCell>
        <Typography>{name}</Typography>
        <Typography variant='body2'>{description}</Typography>
      </TableCell>
      <TableCell>{getTitleByOfferType(type, earningMechanism)}</TableCell>
      <TableCell>
        <MarketingContentPreview
          title={marketingContent?.title || 'No Name Provided'}
          description={marketingContent?.shortDescription || 'No Description Provided'}
          imageUrl={marketingContent?.imageUrl ?? undefined}
        />
      </TableCell>
      <TableCell>{publishedStatusBadge(publishedStatus)}</TableCell>
      <TableCell align='center'>{type !== OfferType.Billboard ? fulfillmentCount : ''}</TableCell>
      <TableCell align='center'>{voucherAward?.voucheredOffer.fulfillmentCount ?? ''}</TableCell>
      {isActionsColumnVisible && (
        <TableCell padding='button' align='right'>
          {!deleted && (
            <CampaignComponentsTableRowActionsContainer
              name={name}
              offerId={id}
              disabled={disabled}
            />
          )}
        </TableCell>
      )}
    </TableRow>
  );
};
